export enum Gateway {
    Cybersource = 'Cybersource',
    PayVector   = 'PayVector',
    Mars        = 'Mars',
}
